"use client";
import React, { useCallback, useEffect, useState } from "react";
import { acquireModalSession, releaseModalSession, subscribeModalSession } from "@/lib/client/modalSession";
import { flushSync } from "react-dom";
import type { ModelOption } from "./BrandIntentLeadForm";
import BrandIntentLeadForm from "./BrandIntentLeadForm";
import { requestMobileLeadKeyboardForNextForm } from "./LeadForm";

const BRAND_REQUEST_MODAL_SESSION_ID = "brand-request-modal";

interface Props {
  models: ModelOption[];
  brandName?: string;
}

const BrandRequestButton: React.FC<Props> = ({ models, brandName }) => {
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleOpen = () => {
    requestMobileLeadKeyboardForNextForm();
    flushSync(() => {
      acquireModalSession(BRAND_REQUEST_MODAL_SESSION_ID);
      setShowModal(true);
    });
  };

  const handleClose = useCallback(() => {
    setShowModal(false);
    releaseModalSession(BRAND_REQUEST_MODAL_SESSION_ID);
  }, []);

  useEffect(() => {
    const unsubscribe = subscribeModalSession((activeId) => {
      if (activeId !== BRAND_REQUEST_MODAL_SESSION_ID) {
        setShowModal(false);
      }
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    return () => releaseModalSession(BRAND_REQUEST_MODAL_SESSION_ID);
  }, []);

  const handleSubmit = () => {
    handleClose();
  };
  const handleError = (msg: string) => setMessage(msg);

  return (
    <>
      <div className="mt-4 flex justify-center">
        <button
          type="button"
          onClick={handleOpen}
          className="inline-flex items-center gap-3 rounded-md bg-sky-100 px-4 py-2 text-sm font-medium text-blue-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-300 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 3 5.18 2 2 0 0 1 5 3h3a2 2 0 0 1 2 1.72c.12 1.21.4 2.39.83 3.5a2 2 0 0 1-.45 2.11L9.5 12.5a16 16 0 0 0 6 6l1.17-1.17a2 2 0 0 1 2.11-.45c1.11.43 2.29.71 3.5.83A2 2 0 0 1 22 16.92z" />
          </svg>
          Request A Callback
        </button>
      </div>

      <BrandIntentLeadForm
        showModal={showModal}
        models={models}
        brandName={brandName}
        onClose={handleClose}
        onSubmit={handleSubmit}
        onError={handleError}
      />
    </>
  );
};

export default BrandRequestButton;
